import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import type { PlatformAPI } from '@ol/kit';

// Drop-in replacement for @auth0/auth0-angular's AuthGuard inside the embedded
// app. Provided via {provide: AuthGuard, useClass: PlatformAuthGuard} so the
// existing route configs that reference AuthGuard keep working unchanged.
@Injectable({ providedIn: 'root' })
export class PlatformAuthGuard implements CanActivate {
  canActivate(): boolean | UrlTree {
    const api = (window as unknown as { __platform__?: PlatformAPI })['__platform__'];
    if (!api) {
      console.warn('[platform-guard] no window.__platform__ available — blocking');
      return false;
    }
    if (api.auth.isAuthenticated()) {
      return true;
    }
    console.warn('[platform-guard] not authenticated — triggering platform.auth.login');
    void api.auth.login(window.location.pathname);
    return false;
  }
}
